import React from "react";

import Spinner from "../../atoms/Spinner";

import styles from "./Loading.module.scss";

const Loading = () => (
  <div className={styles.loading}>
    <Spinner spinColor="black" />
  </div>
);

export default Loading;
